
import {
  defineComponent,
  ref,
  onBeforeMount,
  watch,
  toRaw,
  computed,
} from "vue";
import { ErrorMessage, Field, Form } from "vee-validate";
import * as Yup from "yup";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Actions } from "@/store/enums/StoreEnums";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import AuthAside from "@/components/page-layouts/AuthAside.vue";
import { useI18n } from "vue-i18n";
import useLocale from "@/core/common/useLocale";
export default defineComponent({
  name: "sign-up",
  components: {
    Field,
    Form,
    ErrorMessage,
    AuthAside,
  },
  inject: ["ismobile"],
  setup() {
    const store = useStore();
    const router = useRouter();
    const { t } = useLocale();

    const token = router.currentRoute.value.params.id;

    const submitButton = ref<HTMLButtonElement | null>(null);

    const registration = Yup.object().shape({
      password: Yup.string()
        .matches(/[a-z]+/, t("Use lowercase character"))
        .matches(/[A-Z]+/, t("Use uppercase character"))
        .matches(
          /[!"#$%&'()*+,-./:;<=>?@[\]^_'{|}~]+/,
          t("Use special character")
        )
        .min(12, t("Password must be at least 12 characters"))
        .required(t("Password is a required field"))
        .label("Password"),
      password_confirmation: Yup.string()
        .required(t("Password is a required field"))
        .oneOf(
          [Yup.ref("password"), null],
          t("The password and its confirm are not the same")
        )
        .label(t("Password Confirmation")),
    });

    const onChangePassword = async (values) => {
      /*const token = router.currentRoute.value.params.id;*/
      values["token"] = token;
      await store.dispatch(Actions.POST_RESET_PASSWORD_ACTION, values);
      const isOKreset = store.getters.GetPasswChanged;
      //console.log(store.getters.getErrors);
      /*const [errorName] = Object.keys(store.getters.getErrors);
      const error = store.getters.getErrors[errorName];*/
      /*watch(
          () => store.getters.getErrors,
          function (getError) {
            let error = toRaw(getError);

            if (error.data.success === false) {
              Swal.fire({
                text: error.data.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Ok, got it!",
                customClass: {
                  confirmButton: "btn fw-bold btn-light-primary",
                },
              });
            }
          });*/
      if (isOKreset) {
        Swal.fire({
          text: t("You have successfully changed your password!"),
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: t("Ok, got it!"),
          customClass: {
            confirmButton: "btn fw-bold btn-light-primary",
          },
        }).then(() => router.push({ name: "sign-in" }));
      } else {
        Swal.fire({
          text: t("There was an error."),
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: t("Try again!"),
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger",
          },
        });
      }
    };

    return {
      registration,
      onChangePassword,
      submitButton,
      ...useLocale(),
      visibility: "password",
      visibility_confirmation: "password",
    };
  },

  methods: {
    showPassword() {
      this.visibility = "text";
    },
    hidePassword() {
      this.visibility = "password";
    },
    showPasswordConfirmation() {
      this.visibility_confirmation = "text";
    },
    hidePasswordConfirmation() {
      this.visibility_confirmation = "password";
    },
  },
});
